module.exports = __webpack_public_path__ + "media/images/trust-icon-trophy-1eb9f28e7642ea4331efe1b35c61a5d6.svg";